module.exports = __webpack_public_path__ + "static/images/styles/images/leaderboards/battle_mode_10.2650e54d.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/leaderboards/battle_mode_10.png
// module id = 3654
// module chunks = 11